/* globals dataLayer: false */
import $ from 'jquery'
import memoize from 'lodash/memoize'
import { sha256 as Sha256 } from 'sha.js'
import Event from 'base/event'
import Hub from 'base/hub'
import store from 'base/store'

function insertGTMScript() {
  ;(function (w, d, s, l, i) {
    w[l] = w[l] || []
    w[l].push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
    })
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l != 'dataLayer' ? '&l=' + l : ''
    j.async = true
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl
    f.parentNode.insertBefore(j, f)
  })(window, document, 'script', 'dataLayer', window.gtm)
}

function insertGTMBody() {
  $('<iframe />', {
    width: '1',
    height: '1',
    frameborder: '0',
    style: 'display:none;visibility:hidden',
    src: `https://www.googletagmanager.com/ns.html?id=${window.gtm}`,
  }).prependTo('body')
}

const getHashedValue = memoize(value => {
  if (!value) {
    return null
  }

  const sha = new Sha256()
  return sha.update(value.toString()).digest('hex')
})

function fireGTMProductPageView(event, params = {}) {
  window.google_product_sku = params.product?.id
  window.google_product_name = params.product?.display_name
  window.google_product_value = params.product?.price
  window.google_product_currency = 'USD'
  window.google_product_category_id = params.primary_collection?.id
  window.google_product_category = params.collection?.breadcrumb_title

  dataLayer.push({
    event: 'gtm-pdp-page-view',
  })
}

function fireGTMPageView() {
  dataLayer.push({
    event: 'gtm-page-view',
  })
}

function fireGTMAddToCart(event, params = {}) {
  window.google_product_sku = params.variant?.id
  window.google_product_name = params.variant?.display_name
  window.google_product_value = params.variant?.price
  window.google_product_currency = 'USD'
  window.google_product_category_id = params.collection?.id
  window.google_product_category = params.collection?.breadcrumb_title

  dataLayer.push({
    event: 'gtm-add-to-cart',
  })
}

function fireGTMCheckoutComplete(event, params = {}) {
  const lineItemsIds = []
  const lineItemNames = []
  const lineItemPrices = []
  const lineItems = params.line_items || []

  lineItems.forEach(lineItem => {
    lineItemsIds.push(lineItem?.product_id)
    lineItemNames.push(lineItem?.display_name)
    lineItemPrices.push(lineItem?.price_in_usd)
  })

  window.google_checkout_total_revenue = params.total_in_usd
  window.google_order_id = params.number
  window.google_checkout_lineitem_ids = lineItemsIds
  window.google_checkout_lineitem_names = lineItemNames
  window.google_checkout_lineitem_prices = lineItemPrices
  window.google_checkout_currency = 'USD'
}

export function setUserActivationStatus(segment) {
  window.google_user_activation_status = segment ?? 'unactivated'
}

export function fireGTMSession() {
  const { user, visitor } = store.getState().session

  window.google_session_id = visitor.session_id
  window.google_user_id = user?.id
  window.google_user_hashed_email = getHashedValue(user?.email)
}

function fireGTMSignIn() {
  const { user, visitor } = store.getState().session
  window.google_session_id = visitor.session_id
  window.google_user_id = user?.id
  window.google_user_hashed_email = getHashedValue(user?.email)

  dataLayer.push({
    event: 'gtm-user-sign-in',
  })
}

function fireGTMSignUp() {
  const { user, visitor } = store.getState().session
  window.google_session_id = visitor.session_id
  window.google_user_id = user?.id
  window.google_user_hashed_email = getHashedValue(user?.email)

  dataLayer.push({
    event: 'gtm-user-sign-up',
  })
}

function setupGTM() {
  if (!store.getState().appConfig.isProductionLike) {
    return
  }

  window.gtm = 'GTM-TRD22RH'
  insertGTMScript()
  insertGTMBody()

  fireGTMSession()

  Hub.sub(
    Event.App.ROUTE,
    (event, { path }) => {
      dataLayer.push({
        event: 'pageview',
        page: {
          path,
        },
      })
    },
    { late: true },
  )

  Hub.sub(Event.Product.PAGE_VIEW, fireGTMProductPageView, { late: true })
  Hub.sub(Event.App.ROUTE, fireGTMPageView, { late: true })
  Hub.sub(Event.Checkout.ADD_TO_CART, fireGTMAddToCart, { late: true })
  Hub.sub(Event.Checkout.COMPLETE, fireGTMCheckoutComplete, { late: true })
  Hub.sub(Event.User.SIGN_IN, fireGTMSignIn, { late: true })
  Hub.sub(Event.User.SIGN_UP, fireGTMSignUp, { late: true })
}

export default setupGTM
